<template>
  <section>
    <h2>API利用方法</h2>
    <p>APIの利用方法については、以下の手順に従ってください。</p>
    <ol>
      <li>ログインする。</li>
      <li>ユーザーページからパーソナルトークンを取得する。</li>
      <li>リクエストヘッダーにパーソナルトークンを記述する。</li>
      <li>エンドポイントにリクエストを送信するコードを書く。</li>
    </ol>
  </section>
  <section>
    <h3>サンプルコード（JavaScript）</h3>
    <pre>
<code>// パーソナルトークンを設定
const personalToken = 'YOUR_PERSONAL_TOKEN';
// APIのベースURL
const baseURL = '/api/';
// エンドポイント
const endpoint = 'your-endpoint';
// リクエストヘッダーを設定
const headers = { 'Authorization': `Bearer ${personalToken}` };
// データを取得する関数
async function fetchData() {
  try {
    const response = await fetch(`${baseURL}${endpoint}`, { headers });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    console.log(data);
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
}
// 関数を呼び出してデータを取得
fetchData();
</code>
    </pre>
  </section>
</template>

<style>
pre {
  overflow-x: auto; /* 横スクロールを有効にする */
  background: #404040; /* 背景色 */
  padding: 1em; /* 内側の余白 */
  border-radius: 5px; /* 角の丸み */
  margin-bottom: 1em; /* 下の余白 */
}
code {
 padding: 0.2em 0.3em; /* 内側の余白 */
 margin: 0 0.2em; /* 外側の余白 */
 color: #f8f8f8; /* 文字色 */
 font-size: 0.9em; /* 文字サイズ */
}
</style>